<template>

     <sui-form>
        <sui-form-fields fields="two">
            <sui-form-field required>
                <label>Fecha de expiración de usuario</label>
                <v-date-picker v-model="user.expirationDate" :masks="masks">
                    <template v-slot="{ inputValue, inputEvents }">
                        <input
                            class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
                            :value="inputValue"
                            v-on="inputEvents"
                        />
                    </template>
                </v-date-picker>
            </sui-form-field>
        </sui-form-fields>
        <sui-form-fields fields="four">
            <sui-form-field required>
                <label>Primer nombre</label>
                <input
                    v-model="user.firstName"
                />
            </sui-form-field>

            <sui-form-field>
                <label>Segundo nombre</label>
                <input
                    v-model="user.middleName"
                />
            </sui-form-field>

            <sui-form-field required>
                <label>Apellido Paterno</label>
                <input
                    v-model="user.fatherSurname"
                />
            </sui-form-field>

            <sui-form-field required>
                <label>Apellido materno</label>
                <input
                    v-model="user.motherSurname"
                />
            </sui-form-field>
        </sui-form-fields>

        <sui-form-fields fields="four">
            <sui-form-field required>
                <label>Fecha de nacimiento</label>
                <v-date-picker v-model="user.birthdate" :masks="masks">
                    <template v-slot="{ inputValue, inputEvents }">
                        <input class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300" :value="inputValue" v-on="inputEvents" />
                    </template>
                </v-date-picker>
            </sui-form-field>

            <sui-form-field required>
                <label>País nacimiento</label>
                <sui-dropdown
                    placeholder="Selecciona una opción"
                    selection
                    search
                    :options="countries"
                    v-model="user.birthCountryCode"
                />
            </sui-form-field>

            <sui-form-field required>
                <label>Estado nacimiento</label>
                 <sui-dropdown
                    placeholder="Selecciona una opción"
                    selection
                    search
                    :options="states"
                    v-model="user.birthStateCode"
                />
            </sui-form-field>
            <sui-form-field required>
                <label>Ciudad nacimiento</label>
                <sui-dropdown
                    placeholder="Ciudad de nacimiento"
                    selection
                    search
                    :options="locations"
                    v-model="user.birthCityCode"
                />
            </sui-form-field>
        </sui-form-fields>

       <sui-form-fields fields="four">
            <sui-form-field>
                <label>Teléfono Casa</label>
                <input
                    type="number"
                    v-model="user.phone"
                />
            </sui-form-field>
            <sui-form-field required>
                <label>Celular</label>
                <input
                    type="number"
                    v-model="user.cellphone"
                />
            </sui-form-field>
            <sui-form-field>
                <label>Correo electrónico</label>
                <input
                    disabled
                    v-model="user.email"
                />
            </sui-form-field>
            <sui-form-field required>
                <label>Sexo</label>
                 <sui-dropdown
                    placeholder="Selecciona una opción"
                    selection
                    :options="genderOptions"
                    v-model="user.gender"
                />
            </sui-form-field>
        </sui-form-fields>

        <sui-form-fields fields="four">
            <sui-form-field required>
                <label>RFC</label>
                <input
                    v-model="user.rfc"
                />
            </sui-form-field>
            <sui-form-field required>
                <label>CURP</label>
                <input
                    v-model="user.curp"
                />
            </sui-form-field>
            <sui-form-field>
                <label>NSS</label>
                <input
                    v-model="user.nss"
                />
            </sui-form-field>
            <sui-form-field>
                <label>Estado civil</label>
                 <sui-dropdown
                    placeholder="Selecciona una opción"
                    selection
                    :options="maritalStatusOptions"
                    v-model="user.maritalStatus"
                />
            </sui-form-field>
        </sui-form-fields>

     <sui-form-fields fields="two">
            <sui-form-field width='four' required>
                <label>Código postal</label>
                <input
                    @change="setColoniesOptions"
                    v-model="user.postalCode"
                />
            </sui-form-field>
            <sui-form-field width='twelve' required>
                <label>Calle y número</label>
                <input
                    v-model="user.address"
                />
            </sui-form-field>
        </sui-form-fields>

      <sui-form-fields fields="four">
            <sui-form-field required>
                <label>Colonia residencia</label>
                  <sui-dropdown
                    placeholder="Selecciona una opción"
                    selection
                    :options="colonies"
                    v-model="user.colonyId"
                />
            </sui-form-field>
            <sui-form-field required>
                <label>Municipio residencia</label>
                 <sui-dropdown
                    placeholder="Selecciona una opción"
                    selection
                    search
                    :options="locations"
                    v-model="user.cityCode"
                />
            </sui-form-field>

            <sui-form-field required>
                <label>Estado residencia</label>
                <sui-dropdown
                    required
                    placeholder="Selecciona una opción"
                    selection
                    search
                    :options="states"
                    v-model="user.stateCode"
                />
            </sui-form-field>
            <sui-form-field required>
                <label>País residencia</label>
                <sui-dropdown
                    placeholder="Selecciona una opción"
                    selection
                    search
                    :options="countries"
                    v-model="user.countryCode"
                />
            </sui-form-field>
        </sui-form-fields>

        <sui-form-fields fields="four">
            <sui-form-field>
                <label>Nivel de estudios</label>
                <sui-dropdown
                    placeholder="Selecciona una opción"
                    selection
                    :options="studiesOptions"
                    v-model="user.studies"
                />
            </sui-form-field>

            <sui-form-field>
                <label>Profesión</label>
                <input
                    v-model="user.profession"
                />
            </sui-form-field>

            <sui-form-field>
                <label>Años de experiencia</label>
                <input
                    v-model="user.expertise"
                />
            </sui-form-field>
            <sui-form-field>
                <label>Porcentaje de inglés</label>
                <input
                    v-model="user.englishLevel"
                />
            </sui-form-field>
        </sui-form-fields>

        <sui-form-fields fields="four">
            <sui-form-field required>
                <label>Fecha de Ingreso</label>
                <v-date-picker v-model="user.dateAdmission" :masks="masks">
                    <template v-slot="{ inputValue, inputEvents }">
                        <input
                            class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
                            :value="inputValue"
                            v-on="inputEvents"
                        />
                    </template>
                </v-date-picker>
            </sui-form-field>
            <sui-form-field required>
                <label>Área</label>
                <sui-dropdown
                    multiple
                    placeholder="Selecciona una opción"
                    selection
                    :options="areasOptions"
                    v-model="user.area"
                />
            </sui-form-field>
            <sui-form-field required>
                <label>Puesto</label>
                <input
                    v-model="user.position"
                />
            </sui-form-field>
            <sui-form-field>
                <label>Contrato</label>
                <sui-dropdown
                    placeholder="Selecciona una opción"
                    selection
                    :options="contractTypeOptions"
                    v-model="user.contractType"
                    @input="toggleActive"
                />
            </sui-form-field>
        </sui-form-fields>

        <sui-form-fields fields="four">
            <sui-form-field width="six" required>
                <label>Líder</label>
                 <sui-dropdown
                    placeholder="Selecciona una opción"
                    selection
                    :options="users"
                    v-model="user.leaderId"
                />
            </sui-form-field>
            <sui-form-field width="two">
                <label>Personal a su cargo</label>
                <sui-checkbox
                    toggle
                    v-model="user.hasPersonal"
                />
            </sui-form-field>

            <sui-form-field width="two">
                <label>Activo</label>
                <sui-checkbox
                    v-model="user.active"
                    toggle
                />
            </sui-form-field>
            <sui-form-field width="two">
                <label>¿Es externo?</label>
                <sui-checkbox
                    v-model="user.isExternal"
                    toggle
                />
            </sui-form-field>
        </sui-form-fields>
    </sui-form>
</template>

<script>
import RegionsService from '../../services/RegionsService'
import UserService from '../../services/UserService'
import Gender from '../../common/Gender'
import MaritalStatus from '../../common/MaritalStatus'
import Studies from '../../common/Studies'
import Areas from '../../common/Areas'
import ContractTypes from '../../common/ContractTypes'
import Utils from '@/common/Utils.js'

export default {
    name: 'GeneralData',
    props: ['user'],
    data: function () {
        return {
            colonies: [],
            countries: [],
            states: [],
            locations: [],
            users: [],
            masks: { input: 'YYYY/MM/DD' }
        }
    },
    beforeMount () {
        this.setCountriesOptions()
        this.setStatesOptions()
        this.setLocationsOptions()
        this.setUsersOptions()
    },
    mounted () {
        if (!this.user.birthCountryCode) this.user.birthCountryCode = 'MEX'
        if (!this.user.birthStateCode) this.user.birthStateCode = '08'
        if (!this.user.birthCityCode) this.user.birthCityCode = '00919003'
    },
    watch: {
        'user.postalCode' (newVal, oldVal) {
            if (newVal) this.setColoniesOptions()
        }
    },
    methods: {
        toggleActive () {
            this.user.active = this.user.contractType !== ContractTypes.TERMINACION_LABORAL
        },
        async setUsersOptions () {
            const { items } = await UserService.getAll()

            this.users = items.filter(_ => _.hasPersonal).map(user => {
                return { key: user.id, text: user.fullName, value: user.id }
            })
        },
        async setCountriesOptions () {
            const countries = await RegionsService.getCountries()

            this.countries = countries.map(country => {
                return { key: country.countryCode, text: country.countryName, value: country.countryCode }
            })
        },
        async setStatesOptions () {
            const states = await RegionsService.getStates(this.user.birthCountryCode || 'MEX')

            this.states = states.map(state => {
                return { key: state.stateCode, text: state.stateName, value: state.stateCode }
            })
        },
        async setLocationsOptions () {
            const locations = await RegionsService.getLocations(this.user.birthStateCode)

            this.locations = locations.map(location => {
                return { key: location.locationCode, text: location.locationName, value: location.locationCode }
            })
        },
        async setColoniesOptions () {
            const colonies = await RegionsService.getColonies(this.user.postalCode)

            this.colonies = colonies.map(colony => {
                return { key: colony.colonyId, text: colony.colony, value: colony.colonyId }
            })

            if (colonies.length > 0) {
                const { locationCode, stateCode, countryCode } = colonies[0]

                this.user.cityCode = locationCode
                this.user.stateCode = stateCode
                this.user.countryCode = countryCode
            }
        }
    },
    computed: {
        contractTypeOptions () {
            return Utils.displayOptions(ContractTypes)
        },
        areasOptions () {
            return Utils.displayOptions(Areas)
        },
        studiesOptions () {
            return Utils.displayOptions(Studies)
        },
        genderOptions () {
            return Utils.displayOptions(Gender)
        },
        maritalStatusOptions () {
            return Utils.displayOptions(MaritalStatus)
        }
    }
}
</script>

<style>

</style>
